/*LIBRARY*/
import { useState, useEffect } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";

/*REDUX*/
import { createLayer } from "../../App/actions/layerNewActions";
import { setEditGeometry } from "../../App/actions/layerActions";
import { set_value_layer } from "../../App/actions/layerActions";

/*PICTURE*/

/*FUNCTION*/
import { select_field_from_default_props } from "../../App/validation/generateGeoJson";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const CreateLayer = ({ auth, project, layer, createLayer }) => {
  const [state, setState] = useState({
    name: "",
    description: "",
    type: "Point",
    user_id: auth.user._id,
    folder: "",
    modal_warn: false,
  });

  const { name, description, type, folder, modal_warn, user_id } = state;

  useEffect(() => {
    const { _id } = auth.user;
    setState((prevState) => ({ ...prevState, user_id: _id }));
  }, [auth.user]);

  const toggle_warn = () => {
    setState((prevState) => ({
      ...prevState,
      modal_warn: !prevState.modal_warn,
    }));
  };

  const handleChange = (e) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { geo_project } = project;

    if (!name) {
      toggle_warn();
    } else {
      const fields = select_field_from_default_props(type);

      //khusus_danamas

      const body = {
        name,
        description,
        type,
        folder,
        user_id,
        geo_project_id: geo_project._id,
        fields: [],
        properties: fields,
        status: "digitasi",
        architecture: "v2",
      };
      createLayer(body);

      setState((prevState) => ({
        ...prevState,
        name: "",
        description: "",
        type: "Point",
        user_id: auth.user._id,
        folder: "",
      }));
    }
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //global props
  const { geo_project, loadingDetail } = project;
  const { loadingProcess, itemLoading } = layer;

  //content
  const modal_warn_content = modal_warn && (
    <Modal modalSize="small" isOpen={modal_warn} onClose={toggle_warn}>
      <div className="box-body" id="box-body">
        {dict?.["Please fill in the layer name first"]?.[language]}
      </div>
    </Modal>
  );

  const { folders } = geo_project;
  let folders_state = [];
  if (!loadingDetail && geo_project.folders) {
    folders_state = folders.slice();
    folders_state.unshift({
      name: dict?.["Outside folders"]?.[language],
      _id: "",
    });
  }

  const layer_type_array = ["Point", "LineString", "Polygon"];
  let button_content;
  if (loadingProcess && itemLoading === "createLayer") {
    button_content = (
      <div type="submit" className="button mapid_blue">
        {dict?.["Create Layer"]?.[language]}...
      </div>
    );
  } else {
    button_content = (
      <button
        type="submit"
        className={`button ${name ? "mapid_blue" : "background_grey"}`}
        data-mapid="clickCreate"
      >
        {dict?.["Create Layer"]?.[language]}
      </button>
    );
  }

  const content = (
    <main>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder={dict["Layer name"][language]}
          autoComplete="off"
          className="input_new"
          name="name"
          value={name}
          onChange={handleChange}
          data-mapid="inputLayerName"
        />
        <textarea
          type="text"
          placeholder={dict["Layer description"][language]}
          autoComplete="off"
          className="input_new"
          name="description"
          value={description}
          onChange={handleChange}
          data-mapid="inputLayerDeskription"
        />
        <select
          id="layer_type"
          name="type"
          value={type}
          className="input_new"
          onChange={handleChange}
          data-mapid="selectType"
        >
          {layer_type_array.map((type, idx) => {
            return (
              <option key={idx} value={type}>
                {type}
              </option>
            );
          })}
        </select>
        <select
          id="folder"
          name="folder"
          value={folder}
          className="input_new"
          onChange={handleChange}
          data-mapid="selectFolder"
        >
          {folders_state.map(({ _id, name }, idx) => {
            return (
              <option key={idx} value={_id}>
                {name}
              </option>
            );
          })}
        </select>
        <div>{button_content}</div>
      </form>
    </main>
  );

  return (
    <main>
      {content}
      {modal_warn_content}
    </main>
  );
};

const mapStateToProps = (state) => ({
  project: state.project,
  layer: state.layer,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  createLayer,
  setEditGeometry,
  set_value_layer,
})(CreateLayer);
